module.exports = __webpack_public_path__ + "f630e86d5ffa85fcec7bdb72f410ab06.png";